import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _set from "lodash/set";
import _get from "lodash/get";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import Colors from "../Color/Colors";
import { backgroundBgColors } from "../Background/Background";
import { Theme } from "../Background/Theme/Theme";
import { Text } from "../Text/Text/Text";
import styles from "./Table.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var tableBackgroundColors = [].concat(_toConsumableArray(backgroundBgColors), ['#000000']);
export var tableBorderColors = ['#000000', '#FFFFFF',
// WW500
'#F4F5F9',
// WW510
'#0705171A',
// WW530 (10% opacity)
'#5A577D',
// WW730
'#5A577D',
// WW560
'#070517' // WW000
];
// Valid width is one or more integers followed by px or %
var widthRegex = /^\d+(px|%)/;
export var Table = function Table(_ref) {
  var _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? [] : _ref$columns,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? [] : _ref$rows,
    headingCell = _ref.headingCell;
  var defaultAttributes = {
    borderColor: Colors.colorBlack,
    borderColumns: false,
    borderRows: false,
    borderTable: false,
    borderWidth: 0,
    cellPaddingX: 0,
    cellPaddingY: 0,
    cellSpacing: 0,
    minWidth: 0,
    rowHeadingWidth: '',
    showColumnHeadings: true,
    showRowHeadings: true,
    theme: 'lightBackground'
  };
  var calculateSpan = function calculateSpan(list, mergeKey) {
    var span = 1;
    for (var idx = 0; idx < list.length; idx++, span++) {
      if (!_get(list[idx], mergeKey)) {
        break;
      }
    }
    return span;
  };
  var borderStyle = function borderStyle() {
    return attributes.borderWidth ? "".concat(attributes.borderWidth, "px solid ").concat(attributes.borderColor) : '';
  };
  var setCellPadding = function setCellPadding(cellAttributes, tableAttributes) {
    if (tableAttributes.cellPaddingX && tableAttributes.cellPaddingX > 0) {
      _set(cellAttributes, 'style.paddingLeft', "".concat(tableAttributes.cellPaddingX, "px"));
      _set(cellAttributes, 'style.paddingRight', "".concat(tableAttributes.cellPaddingX, "px"));
    }
    if (tableAttributes.cellPaddingY && tableAttributes.cellPaddingY > 0) {
      _set(cellAttributes, 'style.paddingTop', "".concat(tableAttributes.cellPaddingY, "px"));
      _set(cellAttributes, 'style.paddingBottom', "".concat(tableAttributes.cellPaddingY, "px"));
    }
  };
  var tableAttributes = Object.assign({}, defaultAttributes, attributes);
  var style = {};
  if (tableAttributes.borderTable && borderStyle()) {
    style.border = borderStyle();
  }
  if (tableAttributes.minWidth && tableAttributes.minWidth > 0) {
    style.minWidth = "".concat(tableAttributes.minWidth, "px");
  }
  if (tableAttributes.cellSpacing && tableAttributes.cellSpacing > 0) {
    style.borderCollapse = 'separate';
    style.borderSpacing = "".concat(tableAttributes.cellSpacing, "px");
  }

  // Optional Heading Cell in top-left location
  var headingCellBackgroundColor = _get(headingCell, 'backgroundColor');
  var useHeadingCellBackgroundColor = headingCellBackgroundColor && headingCellBackgroundColor !== 'none';
  var headingCellTheme = useHeadingCellBackgroundColor ? _get(headingCell, 'theme', 'lightBackground') : tableAttributes.theme;
  var width = _get(tableAttributes, 'rowHeadingWidth', '').match(widthRegex) ? _get(tableAttributes, 'rowHeadingWidth', '') : '';
  var headingCellAttributes = {};
  if (headingCellBackgroundColor && headingCellBackgroundColor !== 'none') {
    _set(headingCellAttributes, 'style.backgroundColor', headingCellBackgroundColor);
  }
  setCellPadding(headingCellAttributes, tableAttributes);
  if (width) {
    _set(headingCellAttributes, 'style.width', width);
  }
  var headingCellElement = headingCell ? /*#__PURE__*/_createElement("th", _objectSpread(_objectSpread({}, headingCellAttributes), {}, {
    key: 0
  }), /*#__PURE__*/_jsx(Theme, {
    theme: headingCellTheme,
    children: /*#__PURE__*/_jsx(Text, {
      richText: true,
      typog: "bodycopy",
      children: _get(headingCell, 'text')
    })
  })) : /*#__PURE__*/_jsx("th", {});
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsx(Theme, {
      theme: tableAttributes.theme,
      children: /*#__PURE__*/_jsxs("table", {
        className: styles.table,
        style: style,
        children: [tableAttributes.showColumnHeadings && /*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [_get(tableAttributes, 'showRowHeadings') && headingCellElement, columns && columns.map(function (column, colIdx) {
              if (_get(column, 'heading.mergedCol') && colIdx > 0) {
                return null;
              }

              // Column heading background and theme based on either
              // column.heading or column or table, in that order of priority
              var headingBackgroundColor = _get(column, 'heading.backgroundColor');
              var useHeadingBackgroundColor = headingBackgroundColor && headingBackgroundColor !== 'none';
              var colBackgroundColor = _get(column, 'backgroundColor');
              var useColBackgroundColor = colBackgroundColor && colBackgroundColor !== 'none';
              var backgroundColor = useHeadingBackgroundColor ? headingBackgroundColor : colBackgroundColor;
              var theme = useHeadingBackgroundColor ? _get(column, 'heading.theme', 'lightBackground') : useColBackgroundColor ? _get(column, 'theme', 'lightBackground') : tableAttributes.theme;
              var colSpan = calculateSpan(columns.slice(colIdx + 1), 'heading.mergedCol');
              var width = _get(column, 'width', '').match(widthRegex) ? _get(column, 'width', '') : '';
              var colHasBorderLeft = _get(tableAttributes, 'borderColumns') && _get(tableAttributes, 'borderWidth');

              // Load up the cell attributes.
              var attributes = {};
              if (backgroundColor && backgroundColor !== 'none') {
                _set(attributes, 'style.backgroundColor', backgroundColor);
              }
              setCellPadding(attributes, tableAttributes);
              if (width) {
                _set(attributes, 'style.width', width);
              }
              if (colHasBorderLeft) {
                _set(attributes, 'style.borderLeft', borderStyle());
              }
              if (colSpan > 1) {
                attributes.colSpan = colSpan;
              }
              return /*#__PURE__*/_createElement("th", _objectSpread(_objectSpread({}, attributes), {}, {
                key: colIdx + 1
              }), /*#__PURE__*/_jsx(Theme, {
                theme: theme,
                children: /*#__PURE__*/_jsx(Text, {
                  richText: true,
                  typog: "bodycopy",
                  children: _get(column, 'heading.text')
                })
              }));
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: rows && rows.map(function (row, rowIdx) {
            // Row heading background and theme based on either
            // row.heading or row or table, in that order of priority
            var headingBackgroundColor = _get(row, 'heading.backgroundColor');
            var useHeadingBackgroundColor = headingBackgroundColor && headingBackgroundColor !== 'none';
            var rowBackgroundColor = _get(row, 'backgroundColor');
            var useRowBackgroundColor = rowBackgroundColor && rowBackgroundColor !== 'none';
            var backgroundColor = useHeadingBackgroundColor ? headingBackgroundColor : rowBackgroundColor;
            var theme = useHeadingBackgroundColor ? _get(row, 'heading.theme', 'lightBackground') : useRowBackgroundColor ? _get(row, 'theme', 'lightBackground') : tableAttributes.theme;
            var rowSpan = calculateSpan(rows.slice(rowIdx + 1), 'heading.mergedRow');
            var width = _get(tableAttributes, 'rowHeadingWidth', '').match(widthRegex) ? _get(tableAttributes, 'rowHeadingWidth', '') : '';
            var rowHasBorderTop = _get(tableAttributes, 'borderRows') && _get(tableAttributes, 'borderWidth') && (tableAttributes.showColumnHeadings || rowIdx > 0);
            var headingAttributes = {
              rowSpan: 1
            };
            if (backgroundColor && backgroundColor !== 'none') {
              _set(headingAttributes, 'style.backgroundColor', backgroundColor);
            }
            setCellPadding(headingAttributes, tableAttributes);
            if (width) {
              _set(headingAttributes, 'style.width', width);
            }
            if (rowHasBorderTop) {
              _set(headingAttributes, 'style.borderTop', borderStyle());
            }
            if (rowSpan > 1) {
              headingAttributes.rowSpan = rowSpan;
            }

            // HTML row has its own backgroundColor and theme, over which
            // the heading cell and each data cell can add their own.
            return /*#__PURE__*/_jsxs("tr", {
              children: [tableAttributes.showRowHeadings && (!_get(row, 'heading.mergedRow') || rowIdx === 0) && /*#__PURE__*/_jsx(Theme, {
                theme: theme,
                children: /*#__PURE__*/_jsx("th", _objectSpread(_objectSpread({}, headingAttributes), {}, {
                  children: /*#__PURE__*/_jsx(Text, {
                    richText: true,
                    typog: "bodycopy",
                    children: _get(row, 'heading.text')
                  })
                }))
              }), row.cells && row.cells.map(function (cell, idx) {
                if (cell.mergedCol && idx > 0 || cell.mergedRow && rowIdx > 0) {
                  return null;
                }

                // Cell background and theme based on either
                // cell or column or row or table, in that order of priority
                var cellBackgroundColor = _get(cell, 'backgroundColor');
                var useCellBackgroundColor = cellBackgroundColor && cellBackgroundColor !== 'none';
                var colBackgroundColor = _get(columns[idx], 'backgroundColor');
                var useColBackgroundColor = colBackgroundColor && colBackgroundColor !== 'none';
                var rowBackgroundColor = _get(rows[rowIdx], 'backgroundColor');
                var useRowBackgroundColor = rowBackgroundColor && rowBackgroundColor !== 'none';
                var backgroundColor = useCellBackgroundColor ? cellBackgroundColor : useColBackgroundColor ? colBackgroundColor : _get(rows[rowIdx], 'backgroundColor');
                var theme = useCellBackgroundColor ? _get(cell, 'theme', 'lightBackground') : useColBackgroundColor ? _get(columns[idx], 'theme', 'lightBackground') : useRowBackgroundColor ? _get(rows[rowIdx], 'theme', 'lightBackground') : tableAttributes.theme;
                var colSpan = row.cells && calculateSpan(row.cells.slice(idx + 1), 'mergedCol');
                var rowSpan = calculateSpan(rows.slice(rowIdx + 1).map(function (row) {
                  return row.cells && row.cells[idx];
                }), 'mergedRow');
                var width = _get(columns[idx], 'width', '').match(widthRegex) ? _get(columns[idx], 'width', '') : '';
                var rowHasBorderTop = _get(tableAttributes, 'borderRows') && _get(tableAttributes, 'borderWidth') && (tableAttributes.showColumnHeadings || rowIdx > 0);
                var colHasBorderLeft = _get(tableAttributes, 'borderColumns') && _get(tableAttributes, 'borderWidth') && (tableAttributes.showRowHeadings || idx > 0);

                // Load up the cell attributes.
                var attributes = {};
                if (backgroundColor && backgroundColor !== 'none') {
                  _set(attributes, 'style.backgroundColor', backgroundColor);
                }
                setCellPadding(attributes, tableAttributes);
                if (width) {
                  _set(attributes, 'style.width', width);
                }
                if (rowHasBorderTop) {
                  _set(attributes, 'style.borderTop', borderStyle());
                }
                if (colHasBorderLeft) {
                  _set(attributes, 'style.borderLeft', borderStyle());
                }
                if (colSpan && colSpan > 1) {
                  attributes.colSpan = colSpan;
                }
                if (rowSpan > 1) {
                  attributes.rowSpan = rowSpan;
                }
                return /*#__PURE__*/_createElement("td", _objectSpread(_objectSpread({}, attributes), {}, {
                  key: idx + 1
                }), /*#__PURE__*/_jsx(Theme, {
                  theme: theme,
                  children: /*#__PURE__*/_jsx(Text, {
                    richText: true,
                    typog: "bodycopy",
                    children: cell.text
                  })
                }));
              })]
            }, rowIdx + 1);
          })
        })]
      })
    })
  });
};